module.exports = __webpack_public_path__ + "static/img/PH.669b2402.jpg";